import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1387.688,1315.136 L1774.99467,1813.376 L144.274667,1813.376 L531.688,1315.136 L620.968,1386.70933 L1298.408,1386.70933 L1387.688,1315.136 Z M53,932.234667 L448.413333,1248.71467 L53,1756.98133 L53,932.234667 Z M1866.33333,932.288 L1866.33333,1756.928 L1470.92,1248.66133 L1866.33333,932.288 Z M1546.408,-0.0106666667 L1546.408,498.336 L1866.30133,775.669333 L1866.30133,795.616 L1439.63467,1137.056 L1439.63467,106.656 L479.634667,106.656 L479.634667,1137.056 L52.968,795.616 L52.968,775.669333 L372.968,498.336 L372.968,-0.0106666667 L1546.408,-0.0106666667 Z M1013,266.666667 L1013,533.333333 L1279.66667,533.333333 L1279.66667,640 L1013,640 L1013,906.666667 L906.333333,906.666667 L906.333333,640 L639.666667,640 L639.666667,533.333333 L906.333333,533.333333 L906.333333,266.666667 L1013,266.666667 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconInvitationSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconInvitationSolid, _Component);

  var _super = _createSuper(IconInvitationSolid);

  function IconInvitationSolid() {
    _classCallCheck(this, IconInvitationSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconInvitationSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconInvitation",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconInvitationSolid.displayName = "IconInvitationSolid";
  return IconInvitationSolid;
}(Component);

IconInvitationSolid.glyphName = 'invitation';
IconInvitationSolid.variant = 'Solid';
IconInvitationSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconInvitationSolid;
export { IconInvitationSolid };